import StyledActionText from '@/atoms/ActionText/styles';
import Accordion from '@/molecules/Accordion/Accordion';
import breakpoints from '@/theme/constants/breakpoints';
import {sizePx} from '@/theme/helpers/size';
import typography from '@/theme/typography';
import styled from 'styled-components';

export const StyledTitle = styled.p`
  ${typography.Subtitle1}
  margin-bottom: ${sizePx(10)};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StyledEvents = styled.dl`
  display: grid;
  grid-template-columns: ${sizePx(26)} auto;
  column-gap: ${sizePx(2)};
  row-gap: ${sizePx(3)};
  margin: ${sizePx(10)} 0 0;

  > * {
    margin: 0;
  }

  dd + dd {
    grid-column: 1 / span 2;
  }
`;

export const StyledAboutEvents = styled.div`
  display: none;

  ${StyledActionText} {
    display: block;
    margin: ${sizePx(10)} 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media only screen and ${breakpoints.device.m} {
    display: block;
  }
`;

export const StyledAccordion = styled(Accordion)`
  ${StyledActionText} {
    display: block;
    margin: ${sizePx(10)} 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media only screen and ${breakpoints.device.m} {
    display: none;
  }
`;
